<template>
	<div>
		<h2>期限卡详情</h2>
		<el-row>
			<el-col :span="8">
				<el-form label-width="100px" label-position="left" style="width: 550px;">
					<el-form-item label="卡名">
						<el-input v-model="sendData.name" style="width: 350px;"></el-input>
					</el-form-item>
					<el-form-item label="适用门店">
						<el-select multiple="" v-model="sendData.storeList" style="width: 200px;">
							<el-option-group label="营业门店" class="store">
								<el-option v-for="item in stores" :key="item.id" :value="item.title"
									:label="item.title">
								</el-option>
							</el-option-group>
							<el-option-group label="结业门店">
								<el-option v-for="item in storesEnd" :key="item.id" :value="item.title"
									:label="item.title">
								</el-option>
							</el-option-group>
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="有效期">
						<el-switch v-model="sendData.expiredType" inactive-text="领取后多少天到期"
							active-text="固定日期"></el-switch>
						<div v-if="!sendData.expiredType">
							<el-input-number type="num" size="small" v-model="sendData.day" style="width: 200px">
							</el-input-number>天
						</div>
						<div v-else>
							<el-date-picker type="datetime" v-model="sendData.dueDate" placeholder="有效期至"
								value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
						</div>
					</el-form-item>
					<el-form-item label="服务项">
						<el-select multiple="" v-model="sendData.serviceList" style="width: 200px;">
							<el-option v-for="item in serviceList" :key="item.id" :value="item.title"
								:label="item.title"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="非会员小图">
						<upload v-model="sendData.imgSmallNormal"  class="el-tabs-pane-upload"  ref="sss"
							style="width: 200px; height: 100px;" />
					</el-form-item>
					<el-form-item label="会员小图">
						<upload v-model="sendData.imgSmallMember"  class="el-tabs-pane-upload"  ref="sss"
							style="width: 200px; height: 100px;" />
					</el-form-item>
					<el-form-item label="人数限制">
						<el-switch v-model="sendData.numLimit" inactive-text="不限" active-text="限制"></el-switch>
						<div v-if="sendData.numLimit">
							限<el-input-number v-model="sendData.num" type="num" size="small"
								style="width: 200px;"></el-input-number> 人
						</div>
					</el-form-item>
					<div class="flex" style="width: 100%;justify-content: center;">
						<el-button @click="back()">取消</el-button>
						<el-button type="primary" @click="save()">保存</el-button>
					</div>
				</el-form>
			</el-col>
			<el-col :span="16">
				<div style="display: flex;margin-top: -50px;">
					<div>
						<p style="font-size: 14px;color: #808080;">点击上传非会员详情页图片</p>
						<upload v-model="sendData.imgBigNormal"  class="el-tabs-pane-upload"  ref="sss"
							style="width: 300px; height: 700px;" />
					</div>
					<div style="margin-left: 50px;">
						<p style="font-size: 14px;color: #808080;font-weight: 800;">点击上传会员详情页图片</p>
						<upload v-model="sendData.imgBigMember"  class="el-tabs-pane-upload"  ref="sss"
							style="width: 300px; height: 700px;" />
					</div>
				</div>
			</el-col>
		</el-row>
	</div>
</template>

<script>
	import upload from "../../compents/upload/upload";
	export default {
		components: {
			upload
		},
		data() {
			return {
				sendData: {
					id: '',
					name: '',
					expiredType: false,
					dueDate: '',
					day: 0, //领取多少天后到期
					storeList: [],
					serviceList: [],
				},
				serviceList: [],
				stores: [],
				storesEnd: [],
				time: [],
				id: ''
			}
		},
		mounted() {
			this.getStores()
			this.getServiceList()
			if (this.$route.query.id != null) {
				this.id = this.$route.query.id
				this.getDetail()
			}
		},
		methods: {
			getDetail() {
				this.$http.get("dTimesCard/listById" + "?id=" + this.id).then(res => {
					if (res.body.data != null) {
						this.sendData = res.body.data
						this.$delete(this.sendData, 'addTime')
						let a = []
						if (res.body.data.storeList.length > 1) {
							res.body.data.storeList.split(",").forEach(i => {
								a.push(i)
							})
						} else {
							a.push(res.body.data.storeList)
						}
						this.sendData.storeList = a
						let b = []
						if (res.body.data.serviceList.length > 1) {
							res.body.data.serviceList.split(",").forEach(i => {
								b.push(i)
							})
						} else {
							b.push(res.body.data.serviceList)
						}
						this.sendData.serviceList = b
					}
				})
			},
			getStores() {
				this.$http.get("store/list").then(res => {
					res.body.data.forEach(ele => {
						if (ele.businessType == 1) {
							this.storesEnd.push(ele) //结业门店
						} else {
							this.stores.push(ele) //营业门店
						}
					})
				})
			},
			getServiceList() {
				this.$http.get("dhaircut/list").then(res => {
					this.serviceList = res.body.data
				})
			},
			save() {
				// debugger
				var s = this.sendData
				if (s.serviceList.length > 1) {
					s.serviceList = s.serviceList.join(",")
				} else {
					s.serviceList = s.serviceList[0]
				}
				if (s.storeList.length > 1) {
					s.storeList = s.storeList.join(",")
				} else {
					s.storeList = s.storeList[0]
				}
				if (s.dueDate == '') {
					delete s.dueDate
				}
				// return
				this.$http.post("dTimesCard/save", JSON.stringify(s)).then(res => {
					if (res.body.code == 200) {
						this.$message.success("保存成功")
						this.$router.go(-1)
						// this.$router.push("/timeCard")
					}
				})
			},
			back() {
				this.$router.go(-1)
			},
		}
	}
</script>

<style>
	.flex {
		display: flex;
	}
</style>